<a
  *ngIf="back$ | async as back"
  class="list-back-btn"
  [routerLink]="back.routerLink"
  [fragment]="back.fragment"
  [queryParamsHandling]="back.queryParamsHandling"
  @backButton
>
  <app-svg-icon class="list-back-btn__icon" icon="back" width="1em"></app-svg-icon>

  <span [ngSwitch]="context$ | async" class="list-back-btn__text">
    <ng-container *ngSwitchCase="JobSearchContextEnum.Company" i18n>Revenir aux jobs de l'entreprise</ng-container>
    <ng-container *ngSwitchCase="JobSearchContextEnum.Partner" i18n>Revenir aux jobs des partenaires</ng-container>
    <ng-container *ngSwitchCase="JobSearchContextEnum.Bookmark" i18n>Revenir à la liste des favoris</ng-container>
    <ng-container *ngSwitchDefault i18n>Revenir à la liste</ng-container>
  </span>
</a>

<h2 *ngIf="company$ | async as company" class="list-title"><span i18n>Les offres de</span> “{{ company.name }}”</h2>

<div class="list-ps-outer">
  <perfect-scrollbar class="list-ps" [autoPropagation]="true" [scrollIndicators]="true" (psYReachEnd)="loadMore()">
    <aside>
      <ul class="list" [@list]="loading$ | async">
        <li *ngIf="!!wizbiiDomain && wizbiiDomain !== 'undefined' && locale === LocaleEnum.fr_FR">
          <wiz-media [attr.domain]="wizbiiDomain" cookiekey="wizbii_tokens" spot="JobNativeSidebarAdWizbii"></wiz-media>
        </li>
        <li
          *ngFor="let job of (hits$ | async) || []; trackBy: trackById; let index = index"
          class="list__item"
          [class.list__item--active]="job.id === (jobId$ | async)"
          [attr.aria-current]="job.id === (jobId$ | async) ? 'true' : null"
        >
          <app-mini
            [model]="job"
            [showCompany]="true"
            [bookmark]="(bookmarkMap$ | async)?.get(job.id)"
            (toggleBookmark)="toggleBookmark(job)"
            [trackingData]="(trackingDataMap$ | async)?.get(job.id)"
            queryParamsHandling="merge"
            [queryParams]="{ 'query-id': queryId$ | async }"
          ></app-mini>
        </li>
      </ul>

      <ng-container *ngIf="loading$ | async">
        <app-mini-skeleton *ngFor="let tmp of [0, 1, 2, 3]; trackBy: trackByIndex"></app-mini-skeleton>
      </ng-container>
    </aside>
  </perfect-scrollbar>
</div>
